import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { List } from 'immutable';
import {Col, FormGroup, FormControl, OverlayTrigger, Tooltip, Popover, Row} from 'react-bootstrap';
import Select from 'react-select';
import { AdvancedSearchTerm, SearchTerm } from '../../utils/searchUtils';

function SearchAdvancedForm({ metatagList, onRemoveClick, onChange, rowIndex, searchTerm, intl }) {
  const metatagOptions = [];

  metatagList.map((metatag) => {
    const category = metatag.getIn(['CATEGORY', 0]);
    let newCat = true;
    for (const i in metatagOptions) {
      const metatagGroup = metatagOptions[i];
      if (metatagGroup.id === category) {
        newCat = false;
        metatagGroup.options.push({
          value: `${metatag.getIn(['CATEGORY', 0])}.${metatag.getIn(['TAG_NAME', 0])}`,
          label: metatag.getIn(['DISPLAY_VALUE', 0]) || metatag.getIn(['TAG_NAME', 0]),
          type: metatag.getIn(['TYPE', 0]),
        });
      }
    }

    if (newCat) {
      metatagOptions.push({
        id: category,
        label: category,
        options: [{
          value: `${metatag.getIn(['CATEGORY', 0])}.${metatag.getIn(['TAG_NAME', 0])}`,
          label: metatag.getIn(['DISPLAY_VALUE', 0]) || metatag.getIn(['TAG_NAME', 0]),
          type: metatag.getIn(['TYPE', 0]),
        }],
      });
    }
    return false;
  });

  const onMetatagChange = (e) => {
    // if "any" is chosen, then return as a SearchTerm, otherwise return as MetadataSearchTerm
    let newSearchTerm;

    if (e && e.value) { // it needs to be a MetadataSearchTerm instance
      const metatag = e.value.split('.');
      const options = {
        type: e.type,
        operator: searchTerm.operator,
      };
      newSearchTerm = new AdvancedSearchTerm(
        metatag[0],
        metatag[1],
        searchTerm.value,
        options,
      );
    } else { // needs to be a SearchTerm
      newSearchTerm = new SearchTerm(
        'DEFAULT',
        searchTerm.value,
        { operator: searchTerm.operator }
      );
    }

    onChange(rowIndex, newSearchTerm);
  };
  const msg = (<div>
    for <em>number</em> and <em>date</em> fields, use:<br />
    <strong>RANGE:value1,value2</strong> - search for results within a range<br />
    <strong>LESS:value</strong> - search results with a minimum value <br />
    <strong>GREATER:value</strong> - search results with a maximum value<br /><br />
    EXAMPLES:<br />
      greater:10-OCT-2019<br />
      range:10/10/2019,20/10/2019<br />
      less:100<br />
      range:12,600
      </div>);
  const helpTooltip = (
    <Popover id="popover-trigger-hover-focus" data-html="true">
      {msg}
    </Popover>
  );
  return (
    <Row key={rowIndex}>
      <Col sm={1}>
        {rowIndex > 0 ?
          <button
            onClick={e => onRemoveClick(e, rowIndex)}
            className="search-advanced__remove-icon"
            type="button"
          /> : null}
      </Col>

      <Col sm={1}>
        {rowIndex === 0 ? '' :
        <FormGroup>
          <FormControl
            size="sm"
            as="select"
            className="search-advanced__operator-select"
            onChange={e => onChange(rowIndex, searchTerm.set('operator', e.target.value))}
            value={searchTerm.operator || ''}
          >
            <option value="AND">{intl.formatMessage({ id: 'searchBar.advancedForm.operatorAnd' })}</option>
            <option value="OR">{intl.formatMessage({ id: 'searchBar.advancedForm.operatorOr' })}</option>
            <option value="NOT">{intl.formatMessage({ id: 'searchBar.advancedForm.operatorNot' })}</option>
          </FormControl>
        </FormGroup>
        }
      </Col>
      <Col md={3}>
        <FormGroup>
          <Select
            // deep search the options array for the FULL react-select object for value
            value={_(metatagOptions).map('options').flatten().filter({ value: searchTerm.fullName }).sumBy()}
            className="search-advanced__metatag-select"
            placeholder={intl.formatMessage({ id: 'searchBar.advancedForm.anyMetatagOption' })}
            onChange={onMetatagChange}
            multiselect={false}
            options={metatagOptions}
            openOnFocus
            isClearable
          />
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <FormControl
            size="sm"
            placeholder={intl.formatMessage({ id: 'searchBar.advancedForm.searchTermPlaceholder' })}
            onChange={e => onChange(rowIndex, searchTerm.set('value', e.target.value))}
            value={searchTerm.value || ''}
            type="text"
            className="search-advanced__metatag-input"
          />
        </FormGroup>
      </Col>
      { ['NUMBER', 'DATE'].includes(searchTerm.type) ?
        <Col sm={1}>
          <OverlayTrigger placement="left" overlay={helpTooltip}>
            <span className="far fa-question-circle search-advanced__help" aria-hidden="true"/>
          </OverlayTrigger>
        </Col> : null
      }
    </Row>
  );
}

SearchAdvancedForm.propTypes = {
  metatagList: PropTypes.instanceOf(List),
  onRemoveClick: PropTypes.func,
  rowIndex: PropTypes.number,
  onChange: PropTypes.func,
  searchTerm: PropTypes.oneOfType([
    PropTypes.instanceOf(SearchTerm),
    PropTypes.instanceOf(AdvancedSearchTerm),
  ]),
};

export default injectIntl(SearchAdvancedForm);



// WEBPACK FOOTER //
// ./src/js/components/SearchBar/SearchAdvancedForm.jsx